const themes = [
  {
    name: 'red-alt',
    colorPrimary: '#FFFFFF',
    colorAlternate: '#89303d',
    colorHighlight: '#63232c',
    textPrimary: '#FFFFFF',
    navAlpha: 'rgba(137, 48, 61, 0.75)'
  },
  {
    name: 'indigo-alt',
    colorPrimary: '#FAFAFA',
    colorAlternate: '#303F9F',
    colorHighlight: '#242f78',
    textPrimary: '#FAFAFA',
    navAlpha: 'rgba(48, 63, 159, 0.75)'
  },
  
  {
    name: 'material-cyan',
    colorPrimary: '#000000',
    colorAlternate: '#BBFFFF',
    colorHighlight: '#d4faff',
    textPrimary: '#212121',
    navAlpha: 'rgba(0, 0, 79, 0.75)'
  },
  {
    name: 'blackout',
    firstTime: true,
    colorPrimary: 'rgba(255, 255, 255, 1)',
    colorAlternate: 'black',
    colorHighlight: 'white',
    textPrimary: '#FAFAFA',
    navAlpha: 'rgba(0, 0, 0, 0.75)'
  }
];

export const getThemes = () => {
  return themes.map((theme) => {
    return {
      name: theme.name,
      firstTime: theme.firstTime,
      colorPrimary: theme.colorPrimary,
      colorAlternate: theme.colorAlternate,
      colorHighlight: theme.colorHighlight,
      bgPrimary: theme.colorAlternate,
      bgAlternate: theme.colorPrimary,
      bgLanding: theme.colorPrimary,
      textPrimary: theme.textPrimary,
      textAlternate: theme.colorAlternate,
      textLanding: theme.colorPrimary,
      parallaxStars: theme.colorPrimary,
      navAlpha: theme.navAlpha
    };
  });
};



// WEBPACK FOOTER //
// ./src/components/ThemeSwitcher/themes.js